import React from 'react'
import './Footer.css'
import img1 from './photos/him-chatterjee.jpg'
import img2 from './photos/flag.jpeg'
import { Link } from "react-router-dom";

function Footer() {
    return (
        <>
            <footer>
                {/* <div className='main1'>
                    <h3 style={{ width: '20%', display: 'block', textAlign: 'center' }}>TOP CATEGORIES</h3>
                    <h4>Paintings</h4>
                    <h4>Drawings</h4>
                    <h4>Murals</h4>
                    <h4>Sculptures</h4>
                    <h4>Public Art Works</h4>
                    <h4>SAF Art Gallery</h4>
                    <h4>Miscellaneous Art works</h4>
                </div> */}

                <div className='main2'>
                    <div className='main2_1'>
                        <div className='main2_1_1'>
                            <div className='img_txt'>
                                <img src={img1} width='30px' height='30px' alt="logo" />
                                <h1>PROF. HIM KUMAR CHATTERJEE</h1>
                            </div>
                            {/* <h4>Discover new art and collections added weekly by our curators.</h4>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                className="email_input"
                            /> */}
                            <div className="social_links">
                                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-instagram"></i>
                                </a>
                                <a href="https://www.youtube.com/embed/1HdWVJDAd7E" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-youtube"></i>
                                </a>
                                <a href="https://www.facebook.com/him.chatterjee.9" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-facebook"></i>
                                </a>
                                <a href="https://in.linkedin.com/in/him-chatterjee-a6545722" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-linkedin"></i>
                                </a>
                                <a href="https://in.pinterest.com/himchatterjee9/" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-pinterest"></i>
                                </a>
                            </div>
                        </div>

                        {/* 👉 Address + Google Map */}
                        <div className='main2_1_2'>
                            <div className='address'>
                                <h3>SAF Art Gallery</h3>
                                <p>P. O.- Neri, P.O.- A. G.</p>
                                <p>Shimla ,Himachal Pradesh</p>
                                <p>India, 171003</p>
                                <p><strong>Contact:</strong> 9816060237</p>
                                <p><strong>Email:</strong> himchatterjee@gmail.com </p>
                            </div>

                            <div className='map'>
                                <iframe
                                    title="SAF Art Gallery Location"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3415.396802030626!2d77.14070407538945!3d31.126493174396607!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390579add68c5341%3A0x16db8650daab326a!2sSanat%20Art%20Foundation!5e0!3m2!1sen!2sin!4v1758001727087!5m2!1sen!2sin"
                                    width="100%"
                                    height="200"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                    </div>

                    <div className='main2_2'>
                        <div className='main2_2_2'>
                            <img src={img2} width='20px' height='20px' alt="flag" />
                            <h4>India</h4>
                        </div>

                        <div className='main2_2_3'>
                            <Link to="/admin" style={{ color: "inherit" }}>
                                <h4>© 2025 HIM CHATTERJEE Art. All Rights Reserved.</h4>
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer


